import SubActivityView from '../../sub-activity/sub-activity-view';
import { InteractiveResponseContainer } from '../interactive-response.style';
import {
  InteractiveSequenceAttempt,
  RESPONSE_FREE,
  ViewProps,
} from './settings/interactive-response.constants';
import InteractiveSequenceSmallFree from './play/interactive-sequence-small-free';
import InteractiveResponseSmall from './play/interactive-response-sequence-small';
import { InteractiveResponseMobileWrapper } from '../shared/interactive-response-shared.style';
import type { InteractiveResponseAnswerFragment } from '../../../present/activity-answers.graphql.generated';

const InteractiveSequenceSmallView = ({
  isPlaying,
  finishGame,
  openModal,
  showAnswer,
  ...props
}: ViewProps & {
  openModal?: () => void;
  isPlaying: boolean;
  finishGame: () => void;
  playClick: () => void;
  playStart: () => void;
  toggleAudio: () => void;
  playAudio: boolean;
  onAnswerAttempt: InteractiveSequenceAttempt;
  attemptAnswers?: InteractiveResponseAnswerFragment;
  showAnswer: boolean;
}) => {
  const isFreeResponse =
    props.properties.interactiveResponse.answerType === RESPONSE_FREE;
  return (
    <InteractiveResponseMobileWrapper>
      <SubActivityView
        withTTSButton
        componentId={props.id}
        componentType={props.type}
        subActivityDetails={props.subActivityProperties}
      >
        <InteractiveResponseContainer>
          {isFreeResponse || !showAnswer ? (
            <InteractiveSequenceSmallFree {...props} onClose={finishGame} />
          ) : (
            <InteractiveResponseSmall {...props} onClose={finishGame} />
          )}
        </InteractiveResponseContainer>
      </SubActivityView>
    </InteractiveResponseMobileWrapper>
  );
};

export default InteractiveSequenceSmallView;
